import dayjs from "dayjs";

function stageHasAnyActivity(stage) {
  const dates = Array.isArray(stage?.dates) ? stage.dates : [];
  for (const d of dates) {
    const entered = Array.isArray(d?.entered) ? d.entered : [];
    const approved = Array.isArray(d?.approved) ? d.approved : [];
    const rejected = Array.isArray(d?.rejected) ? d.rejected : [];
    if (entered.length > 0 || approved.length > 0 || rejected.length > 0) return true;
  }
  return false;
}

function stageUniqueCandidateCount(stage) {
  const dates = Array.isArray(stage?.dates) ? stage.dates : [];
  const ids = new Set();
  for (const d of dates) {
    const entered = Array.isArray(d?.entered) ? d.entered : [];
    const approved = Array.isArray(d?.approved) ? d.approved : [];
    const rejected = Array.isArray(d?.rejected) ? d.rejected : [];
    entered.forEach((id) => ids.add(id));
    approved.forEach((id) => ids.add(id));
    rejected.forEach((id) => ids.add(id));
  }
  return ids.size;
}

function buildEmployeeNameIndex(data) {
  const m = new Map();
  const dates = Array.isArray(data?.dates) ? data.dates : [];
  dates.forEach((row) => {
    const items = Array.isArray(row?.items) ? row.items : [];
    items.forEach((it) => {
      if (it?.employeeId == null) return;
      const id = String(it.employeeId);
      if (!m.has(id)) m.set(id, it?.employeeName ?? id);
    });
  });
  return m;
}

export function buildTreeModel(data) {
  const jobs = data?.jobs && typeof data.jobs === "object" ? data.jobs : {};
  const jobList = Object.values(jobs).filter(Boolean);

  const stageOrderRaw = jobList[0]?.stages;
  const stageOrder = Array.isArray(stageOrderRaw)
    ? stageOrderRaw.map((s) => s?.stage).filter(Boolean)
    : [];

  const employeeNameById = buildEmployeeNameIndex(data);
  const jobsByEmployee = new Map();

  jobList.forEach((job) => {
    const employeeId = job?.bdmId ?? "";
    const key = String(employeeId);
    if (!jobsByEmployee.has(key)) jobsByEmployee.set(key, []);
    jobsByEmployee.get(key).push(job);
  });

  const employees = Array.from(jobsByEmployee.entries())
    .map(([employeeId, empJobs]) => {
      const stageCounts = {};
      stageOrder.forEach((stageName) => {
        stageCounts[stageName] = 0;
      });

      empJobs.forEach((job) => {
        const stages = Array.isArray(job?.stages) ? job.stages : [];
        const byName = new Map(stages.map((s) => [s?.stage, s]));
        stageOrder.forEach((stageName) => {
          const stage = byName.get(stageName);
          if (!stageHasAnyActivity(stage)) return;
          stageCounts[stageName] += stageUniqueCandidateCount(stage);
        });
      });

      return {
        employeeId,
        employeeName: employeeNameById.get(employeeId) ?? employeeId,
        jobsOpenCount: empJobs.length,
        stageCounts,
      };
    })
    .sort((a, b) => String(a.employeeName || "").localeCompare(String(b.employeeName || "")));

  return {
    root: { totalJobsOpen: jobList.length },
    stageOrder,
    employees,
    meta: {
      generatedAt: dayjs().toISOString(),
    },
  };
}
